<template>
  <div style="height:100%;">
      <video class="tcplayer player-size" id="player-container-id" preload="auto" playsinline webkit-playinline x5-playinline></video>
      <remote-js src="https://imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.min.js" @completed="initPlayer"></remote-js>
  </div>

</template>

<script>
/* eslint-disable */
export default {
  name: 'qplayer',
  created () {},
  data () {
    return {
      tcPlayer: null
    }
  },
   components: {
     'remote-js': {
      render(createElement) {

        let script = document.createElement('script')

        var emit = () => {this.$emit("completed",{})}
        script.onload = function() {
          emit()
        };
        script.src = this.src
        var head= document.getElementsByTagName('head')[0];
        head.appendChild(script);
        return script
      },
      props: {
        src: { type: String, required: true }
      }
    }
  },
  mounted () {

  },
  props: {
    fileId : {
      type: String,
      default: '5285890783862655353'
    },
    width:{
      type: [Number, String],
      default: 640
    },
    height:{
      type: [Number, String],
      default: 480
    }
  },
  methods: {
    initPlayer: function (data) {
      let uniqueId = `player-container-id${this.fileId}`
      document.getElementById('player-container-id').id = uniqueId
      this.tcPlayer = TCPlayer(uniqueId, { // player-container-id 为播放器容器ID，必须与html中一致
        fileID: this.fileId, // 请传入需要播放的视频filID 必须
        appID: "1257036669", // 请传入点播账号的appID 必须
        autoplay: false, //是否自动播放
        width: String(this.width),
        height: String(this.height),
        plugins:{
          ContinuePlay: { // 开启续播功能
            auto: true, //[可选] 是否在视频播放后自动续播
          // text:'上次播放至 ', //[可选] 提示文案
          // btnText: '恢复播放' //[可选] 按钮文案
        },
      }
      });
    },
  },
  watch: {
    fileId: function(newValue, oldValue){

      this.tcPlayer.loadVideoByID({
        fileID: newValue,
        appID: '1257036669'
      })
      setTimeout(() => {
        this.tcPlayer.play()
      }, 500);
    }
  },
}
</script>

<style scoped>
@import url("https://imgcache.qq.com/open/qcloud/video/tcplayer/tcplayer.css");
.tcplayer {
  margin: 0 auto;
}
.player-size {
  width: 100%;
  height: 100%;
}
/* 通过 css 设置播放器尺寸 这时<video>中的宽高属性将被覆盖*/
/* @media screen and (max-width: 1000px) {
  .player-size {
    width: 100%;
    height: 45vh;
  }
}

@media screen and (max-width: 800px) {
  .player-size {
    width: 100%;
    height: 360px;
  }
}

@media screen and (max-width: 600px) {
  .player-size {
    width: 100%;
    height: 270px;
  }
} */

/* 设置logo在高分屏的显示样式 */
@media only screen and (min-device-pixel-ratio: 2),
  only screen and (-webkit-min-device-pixel-ratio: 2) {
  .tcp-logo-img {
    width: 50%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/qPlayer.vue